module.exports = __webpack_public_path__ + "static/media/logo.87ab5a92.svg";